import { render, staticRenderFns } from "./AddSP.vue?vue&type=template&id=6146bd80"
import script from "./AddSP.vue?vue&type=script&lang=js"
export * from "./AddSP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports